/* eslint-disable camelcase */
export const valueMappings = {
  ht_leadsource: {
    display: '206380014',
    email: '206380024',
    event: '206380003',
    'organic search': '206380007',
    other: '206380023',
    'paid search': '206380013',
    'paid social': '206380006',
    'paid video': '919470000',
    phone: '206380021',
    'print advertising': '206380005',
    'print mail': '206380008',
    referral: '206380004',
    'site visit': '206380011',
    social: '206380012',
    'technical service': '206380001',
    website: '206380018',
    video: '919470001',
  },
  ht_leadsourcedetail: {
    'robotmaster.com': '919470000',
    'omax.com': '692300010',
    'omax dashboard': '692300011',
    'accustream.com': '206380051',
    aisc: '206380033',
    ask: '206380024',
    associate: '206380006',
    baidu: '206380023',
    'Baidu CPC': '206380029',
    'Baidu Display': '206380030',
    bing: '206380022',
    'Bing CPC': '206380028',
    'Bing Display': '206380032',
    'customer success call': '206380012',
    digital: '206380007',
    duckduckgo: '206380026',
    'other email': '206380009',
    'end user': '206380005',
    'other event': '206380003',
    facebook: '206380045',
    'Facebook Advertising': '206380017',
    fastspring: '692300001',
    'global spec': '206380035',
    google: '206380021',
    'Google CPC': '206380027',
    'Google Display': '206380031',
    'hypertherm.com': '692300000',
    instagram: '206380048',
    'Instagram Advertising': '206380020',
    'joint partner visit': '206380040',
    line: '692300008',
    'Line Advertising': '692300007',
    linkedIn: '206380044',
    'LinkedIn Advertising': '206380015',
    naver: '692300006',
    'outbound marketing': '206380010',
    partner: '206380004',
    'phone inquiry': '206380011',
    pinterest: '206380047',
    'plasma spider': '206380036',
    'print mail': '206380038',
    'product qr': '206380053',
    'promotion qr': '206380054',
    'prospecting call': '206380013',
    'other referral': '206380008',
    'sales site visit': '206380039',
    'site assessment': '206380041',
    sogou: '692300004',
    'technical service-site visit': '206380043',
    'technical service call': '206380042',
    'the fabricator': '206380034',
    tiktok: '692300002',
    toutiao: '692300003',
    tradeshow: '206380000',
    twitter: '206380049',
    'Twitter Advertising': '206380019',
    'virtual events': '206380001',
    webinar: '206380002',
    'website-other': '206380052',
    wechat: '206380046',
    'WeChat Advertising': '206380016',
    yahoo: '206380025',
    youtube: '206380050',
    'YouTube Advertising': '206380018',
    'YouTube Display': '692300005',
    'hyperthermassociates.com': '919470001',
    'sales agent': '919470002',
    'event publication': '919470003',
    'trade publication': '919470004',
    other: '919470005',
    whatsapp: '919470006',
    'chatgpt.com': '919470007',
    gemini: '919470008',
    perplexity: '919470009',
    copilot: '919470010',
  },
  ht_opportunitytype_code: {
    'New Business': '206380001',
    Expansion: '692300000',
    Upgrade: '206380003',
    Recapture: '206380000',
    Retrofit: '206380002',
  },
  ht_productmodelline: {
    '3-Series Pump': '692300019',
    Accessories: '692300000',
    'Accustream Consumables': '692300108',
    'Aftersales-Onsite Training': '692300088',
    ArcGlide: '692300057',
    'BLM Group': '919470003',
    'Cartridge RT Torches': '919470009',
    'Cartridge Reader': '692300002',
    'Centricut Consumables': '692300007',
    'Command THC': '692300059',
    'CopperPlus Consumables': '692300008',
    'Cutting Head Consumables': '692300090',
    'D Series Pump': '692300101',
    Design2Fab: '692300066',
    'Dual Intensifier Pump': '692300020',
    'Duramax Consumables': '692300009',
    'Duramax HRT': '692300075',
    'Duramax HRT/MRT': '692300077',
    'Duramax Hyamp Long Torch': '692300081',
    'Duramax Hyamp Torch': '692300080',
    'Duramax Lock': '692300079',
    'Duramax LT': '692300078',
    'Duramax MRT': '692300076',
    'Duramax Torch': '692300074',
    'Duramax-SYNC Cartridge Adapter': '692300001',
    'Echion Pump': '692300103',
    Edge: '692300005',
    'Edge Connect': '692300004',
    'FineCut Consumables': '692300016',
    'FlushCut Consumables': '692300010',
    'FlushCut Duramax Consumables': '692300011',
    'FlushCut Duramax Lock Consumables': '692300012',
    GlobalMAX: '692300021',
    'GlobalMAX 1508': '692300096',
    'GlobalMAX 1530': '692300097',
    'GlobalMAX 2040': '692300098',
    'HD3070 Preventive Maintenance Kit': '692300039',
    'HD4070 Preventive Maintenance Kit': '692300040',
    HPR: '692300022',
    'HPR130 Preventive Maintenance Kit': '692300041',
    'HPR130XD Preventive Maintenance Kit': '692300042',
    'HPR130XD Upgrade Kit': '692300043',
    'HPR260 Preventive Maintenance Kit': '692300044',
    'HPR260XD Preventive Maintenance Kit': '692300045',
    'HPR260XD Upgrade Kit': '692300046',
    HPR400XD: '692300023',
    'HPR400XD Preventive Maintenance Kit': '692300047',
    HPR800XD: '692300024',
    'HPR800XD Preventive Maintenance Kit': '692300048',
    'HPRXD Cartridge': '919470004',
    'HSD130 Preventive Maintenance Kit': '692300049',
    'HT2000 Preventive Maintenance Kit': '692300050',
    'HT4001 Preventive Maintenance Kit': '692300051',
    'HT4400 Preventive Maintenance Kit': '692300052',
    'Hyamp Adapter': '919470008',
    'Hyamp Cartridges': '919470006',
    'HyAccess Consumables': '692300014',
    'HyAccess Duramax Consumables': '692300015',
    'HyPerformance Maintenance Kit': '692300053',
    'HyPerformance Torch': '692300082',
    'Hypilot Cartridges': '919470007',
    lMAX: '692300125',
    LongLife: '692300025',
    'LongLife Preventative Maintenance Kit': '692300054',
    'LongLife Torch': '692300083',
    'MAX200 HyPro Torch': '692300087',
    'MAX200 Preventive Maintenance Kit': '692300055',
    MAXIEM: '692300106',
    'MAXIEM 1515': '692300117',
    'MAXIEM 1530': '692300118',
    'MAXIEM 2030': '692300119',
    'MAXIEM 2040': '692300121',
    'MAXIEM 2060': '692300120',
    'MAXIEM 2080': '692300122',
    'MAXIEM 3060': '692300123',
    MAXPRO200: '692300026',
    'MAXPRO200 Preventive Maintenance Kit': '692300056',
    MicroEdge: '692300006',
    Nozzles: '692300092',
    OMAX: '692300105',
    'OMAX 120X': '692300115',
    'OMAX 160X': '692300116',
    'OMAX 2626': '692300111',
    'OMAX 2652': '692300112',
    'OMAX 55100': '692300114',
    'OMAX 5555': '692300113',
    'OMAX consumables': '692300109',
    'OMAX MicroMAX': '692300110',
    'On/Off Valve': '692300095',
    OptiMAX: '692300104',
    'OptiMAX 60X': '692300099',
    'OptiMAX 80X': '692300100',
    Orifices: '692300091',
    Other: '692300003',
    Powermax: '692300027',
    'Powermax Torch': '692300085',
    'Powermax105 SYNC': '692300034',
    Powermax125: '692300028',
    'Powermax30 AIR': '692300029',
    'Powermax30 XP': '692300030',
    'Powermax33 XP': '919470005',
    'Powermax45 SYNC': '919470000',
    'Powermax45 XP': '692300031',
    'Powermax65 SYNC': '692300032',
    'Powermax85 SYNC': '692300033',
    'Predictive Pump': '692300102',
    'Production Manager': '692300067',
    ProNest: '692300064',
    'ProNest LT': '692300065',
    ProtoMAX: '692300107',
    'Pump Consumables': '692300089',
    'Robotic Command THC': '692300062',
    Robotmaster: '919470002',
    'Robotmaster v6': '692300069',
    'Robotmaster v7': '692300070',
    'Rotary Tube Pro': '692300068',
    'Sensor OHC': '692300058',
    'Sensor PHC': '692300063',
    'Sensor THC': '692300060',
    'SilverPlus Consumables': '692300013',
    'SYNC Consumables': '692300017',
    'SYNC FineCut Drag Cutting Consumables': '692300018',
    'SYNC FineCut Mechanized Consumables': '692300071',
    'SYNC FlushCut Consumables': '692300073',
    'SYNC Gouging Consumables': '692300072',
    'T AIR Torch': '692300084',
    'THC1/THC2': '692300061',
    'Tubing & Fittings': '692300094',
    Waterjet: '692300093',
    XPR: '692300036',
    'XPR Torch': '692300086',
    XPR170: '692300037',
    XPR300: '692300038',
    XPR460: '919470001',
  },
  ht_productclasstype: {
    Training: '919470000',
    Accessories: '692300000',
    CNC: '692300001',
    'Plasma Consumables': '692300002',
    'Plasma Systems': '692300003',
    Kits: '692300004',
    THC: '692300005',
    Torches: '692300006',
    'Software (Perpetual)': '692300008',
    'Software (Subscription)': '692300009',
    'Software (Maintenance Plan)': '692300010',
    'Waterjet System': '692300013',
    'Waterjet Consumables': '692300014',
    'Waterjet Accessories': '692300012',
    Pumps: '692300015',
    'Laser Consumables': '692300011',
    Other: '692300007',
    'Service Contract': '692300016',
    'Laser Systems': '692300017',
  },
  ht_technologyinterest: {
    Plasma: '206380000',
    Laser: '206380001',
    Waterjet: '206380002',
    Software: '206380003',
  },
  ht_platform: {
    Manual: '206380000',
    Mechanized: '206380001',
    'Semi-Automatic': '692300000',
    Robotic: '692300001',
  },
  ht_application: {
    '2D cutting': '206380019',
    '3D cutting': '206380016',
    'Additive Mfg': '206380026',
    'Art Cutting': '206380013',
    'Bevel Cutting / Post Table': '206380002',
    Beveling: '206380001',
    'CAM Other': '206380034',
    'CAM Plasma': '206380032',
    'CO2 Laser Cutting': '206380021',
    'De-burring': '692300008',
    Deflashing: '692300010',
    'Diode Laser Cutting': '206380023',
    Dispensing: '692300007',
    'Dome Cutting': '206380012',
    Drilling: '919470001',
    'Extended Reach Cutting': '206380003',
    'Flat Sheet Cutting': '206380020',
    'Flush Cutting': '206380005',
    Gouging: '206380006',
    'Grinding and Finishing': '692300006',
    'Hole / Fine Feature Cutting': '206380004',
    'Hole Cutting': '206380007',
    Inspection: '206380025',
    'Laser Cutting': '206380031',
    Machining: '692300005',
    'Marking / Etching': '206380008',
    'Material Handling': '919470000',
    'Material Removal': '206380027',
    Milling: '919470002',
    'Near net shape cutting': '206380018',
    Other: '206380015',
    'Paint/Spray/Coating/Surface Treatment': '692300009',
    'Pipe / Tube / Beam Cutting': '206380011',
    'Plasma Cutting': '206380028',
    'Plate Cutting': '206380010',
    'Profile Cutting': '206380014',
    'Robotic Cutting': '206380000',
    'Robotic Other': '206380030',
    'Router Trimming': '919470003',
    'Sheet Metal Cutting': '692300001',
    'Skeleton / Scrap Cutting': '206380009',
    'Solid State Laser Cutting': '206380022',
    'Straight Cutting': '692300004',
    'Surface Treatment': '206380029',
    'SW Recapture': '692300002',
    'Track Burner Bevel': '692300000',
    Trimming: '692300003',
    'Tube cutting': '206380017',
    'Waterjet Cutting': '206380033',
    Welding: '206380024',
  },
  ht_materialshape: {
    'Plate / Sheet': '692300000',
    'Pipe / Tube': '692300001',
    'Hollow Beam': '692300002',
    'Structural Beam': '692300003',
    'Cast / Mold': '692300005',
    'Dome / Cylinder': '692300006',
    Parts: '692300007',
    Skeleton: '692300009',
    Other: '692300008',
    'Bulb flat / Stiffeners': '692300004',
  },
  ht_materialscut: {
    Fiberglass: '919470000',
    Ceramics: '919470001',
    Stone: '919470002',
    Foams: '692300008',
    Iron: '692300009',
    Galvanized: '692300010',
    Carbon: '692300011',
    Steel: '692300012',
    Aluminum: '692300022',
    Brass: '692300000',
    'Carbon Fiber': '692300024',
    Composites: '692300002',
    Copper: '692300025',
    'Bulb flat / Stiffeners': '692300004',
    'Exotic Metals': '692300004',
    Glass: '692300001',
    Inconel: '692300003',
    'Mild Steel': '692300030',
    Other: '692300007',
    Plastics: '692300031',
    PVC: '692300005',
    Rubber: '692300032',
    'Stainless Steel': '692300033',
    Titanium: '692300037',
    UHMW: '692300006',
    Dekton: '919470003',
    Marble: '919470005',
    Neolith: '919470004',
    'Structural Steel': '919470006',
  },
  ht_thicknesscutmostoften: {
    '<6 mm (< 1/4") ': '692300000',
    '6-12 mm (1/4" to 1/2")': '692300001',
    '12-25 mm (1/2" to 1")': '692300002',
    '25-50 mm (1\” to 2\”)': '692300003',
    '50-75 mm (2\” to 3\”)': '692300004',
    '75 to 125 mm (3" to 5")': '692300005',
    '125 to 200 mm (5" to 8")': '692300006',
    '> 200 mm (8") ': '692300007',
  },
  ht_currentcuttingtechnology: {
    Laser: '692300000',
    Plasma: '692300001',
    Waterjet: '692300002',
    Oxyfuel: '692300003',
    Outsourcing: '692300004',
    Other: '692300005',
  },
  ht_dailymachineruntime: {
    '0-3 hours': '692300000',
    '4-7 hours': '692300001',
    '8+ hours': '692300002',
  },
  ht_accuracyrequired: {
    Tight: '692300000',
    Standard: '692300001',
    Loose: '692300002',
  },
  ht_robotbrand: {
    ABB: '919470000',
    Cloos: '919470001',
    Comau: '919470002',
    Denso: '919470003',
    Epson: '919470004',
    Fanuc: '919470005',
    Hiwin: '919470006',
    Hyundai: '919470007',
    Kawasaki: '919470008',
    Kuka: '919470009',
    Leantec: '919470010',
    Mitsubishi: '919470011',
    Nachi: '919470012',
    'No Robot': '919470013',
    OTC: '919470014',
    Other: '919470015',
    Panasonic: '919470016',
    REIS: '919470017',
    Siasun: '919470018',
    Staubli: '919470019',
    Techman: '919470020',
    'Universal Robots': '919470021',
    'Yaskawa/Motoman': '919470022',
  },
  ht_robotprogrammingmethod: {
    'Robot Manufacturer Software': '919470000',
    'Teach Pendant': '919470001',
    'Offline Programming Software': '919470002',
  },
};
